import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Action Details", -1)
const _hoisted_3 = { class: "button--inverted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Manage Action ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Actions can be used to reward players for linking their accounts, joining your Discord guild, Steam group, and more. "),
  /*#__PURE__*/_createElementVNode("span", { class: "high-em" }, "Every time a player is updated, their eligibility is calculated for all actions, after which the corresponding actions are invoked"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_6 = { class: "player__info" }
const _hoisted_7 = { class: "breadcrumbs overflow-container" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Integrations ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_11 = { class: "breadcrumbs__item" }
const _hoisted_12 = { class: "player__created-date" }
const _hoisted_13 = { class: "dashboard__section" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Action Details", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete ")
const _hoisted_16 = { class: "high-em" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_dropdown_button = _resolveComponent("dropdown-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_save_popup = _resolveComponent("save-popup")!
  const _component_action_form = _resolveComponent("action-form")!
  const _component_save_spacer = _resolveComponent("save-spacer")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_dropdown_button, { class: "no-margin-top" }, {
          button: _withCtx(() => [
            _createElementVNode("button", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_fa_icon, { icon: ['fas', 'cog'] })
            ])
          ]),
          options: _withCtx(() => [
            _createElementVNode("li", {
              class: "dropdown-button__option",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal = true))
            }, [
              _createElementVNode("button", {
                class: "dropdown-button__option-button--danger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal = true))
              }, " Delete Action ")
            ])
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "breadcrumbs__item",
            to: `/dashboard/${_ctx.$route.params.subdomain}/integrations`
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_9,
          _createVNode(_component_router_link, {
            class: "breadcrumbs__item",
            to: `/dashboard/${_ctx.$route.params.subdomain}/integrations/${_ctx.integration?.id}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.integration?.name) + " (#" + _toDisplayString(_ctx.integration?.id) + ") ", 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.action?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
          _createTextVNode(" Created " + _toDisplayString(_ctx.formattedDate), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        (_ctx.action)
          ? (_openBlock(), _createBlock(_component_action_form, {
              key: 0,
              ref: "actionForm",
              definitions: _ctx.definitions,
              modelValue: _ctx.action,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.action) = $event)),
              onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_save_popup, {
                  loading: _ctx.loading,
                  show: _ctx.actionChanged,
                  "show-spacer": false
                }, null, 8, ["loading", "show"])
              ]),
              _: 1
            }, 8, ["definitions", "modelValue", "onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_save_spacer)
    ]),
    _withDirectives(_createVNode(_component_modal, {
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDeleteModal = false))
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Delete " + _toDisplayString(_ctx.action?.name), 1)
      ]),
      message: _withCtx(() => [
        _hoisted_15,
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.action?.name), 1),
        _hoisted_17
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_loading_button, {
          "button-type": "button--danger",
          loading: _ctx.deleteLoading,
          onClick: _ctx.deleteAction
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createElementVNode("button", {
          class: "button--no-bg danger no-margin-top",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteModal = false))
        }, " Cancel ")
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showDeleteModal]
    ])
  ], 64))
}